// utils/GlobalErrorHandler.js

import { logToServer } from "./logger";

export function registerGlobalErrorHandlers() {
  // JS runtime errors
  window.onerror = function (message, source, lineno, colno, error) {
    logToServer({
      level: "error",
      message: message?.toString(),
      source,
      lineno,
      colno,
      stack: error?.stack || null,
      type: "window.onerror",
    });
  };

  // Unhandled Promise rejections
  window.onunhandledrejection = function (event) {
    logToServer({
      level: "error",
      message: event.reason?.message || event.reason?.toString(),
      stack: event.reason?.stack || null,
      type: "unhandledrejection",
    });
  };

  // Capture console.error and console.warn (for React dev warnings)
  const origConsoleError = console.error;
  const origConsoleWarn = console.warn;

  console.error = function (...args) {
    logToServer({
      level: "error",
      message: args.map(String).join(" "),
      type: "console.error",
    });
    origConsoleError.apply(console, args);
  };

  console.warn = function (...args) {
    logToServer({
      level: "warn",
      message: args.map(String).join(" "),
      type: "console.warn",
    });
    origConsoleWarn.apply(console, args);
  };
}
